<app-admin-custom-control [label]="label" [centerLabel]="centerLabel" [labelCols]="labelCols"
  [dividerKind]="dividerKind">
  <div *ngFor="let key of objectKeys(radios); let i = index" class="form-check">
    <input type="radio" [(ngModel)]="model" (ngModelChange)="changeModel($event)" [value]="radios[key]"
      [id]="'radio' + uniqueId + i" [name]="'radios' + uniqueId" [disabled]="disabled" class="form-check-input">
    <label class="form-check-label" [for]="'radio' + uniqueId + i">{{key}}</label>
  </div>
</app-admin-custom-control>
